import React from 'react';
import PropTypes from 'prop-types';
import MobileTopNavSmallView from '../../MobileTopNav/MobileTopNavSmallView';
import { MobileActionStepsV2 } from '../../FinancialPlan/ActionStepsV2/ActionStepsV2Container';
import { MobileExplanations } from '../../FinancialPlan/Explanations/ExplanationsContainer';
import { MobileDebtManagementChart } from '../../DebtManagementChart/DebtManagementChartContainer';
import { createCustomPropType, isNumeric, isUuid } from '../../../js/app/react/validators';
import MobileEditGoalButton from '../MobileEditGoalButton/MobileEditGoalButtonContainer';

const MobileRetirementView = (props) => {
  const {
    fpId, clientId, isCurrentPlan, chartData, chartTitle, hasGoal,
  } = props;

  if (!hasGoal) {
    return null;
  }

  return (
    <div className="NewFinancialPlan_retirement">
      <MobileTopNavSmallView onClick={() => window.history.back()} headerText="Debt Management" />
      <div className="mobile-content-scrollable-small-topnav-gray">
        <MobileExplanations clientId={clientId} />
        <div className="mobile-consumer-heading-separator">
          Total Debt
        </div>
        <section className="chart mobile no-padding-bottom less-padding-left less-padding-right">
          <div className="mobile-recommended-target-amount-wrapper">
            <MobileDebtManagementChart
              clientId={clientId}
              chartData={chartData}
              chartTitle={chartTitle}
              isCurrentPlan={isCurrentPlan}
              loaded
            />
          </div>
        </section>
        <MobileActionStepsV2 clientId={clientId} fpId={fpId} />
        <MobileEditGoalButton clientId={clientId} fpId={fpId} />
      </div>
    </div>
  );
};

MobileRetirementView.propTypes = {
  isCurrentPlan: PropTypes.bool.isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  fpId: createCustomPropType(isUuid).isRequired,
  selectedGoalChart: PropTypes.shape({}).isRequired,
  largePurchaseGoal: PropTypes.shape({}).isRequired,
};

export default MobileRetirementView;
